import { render, staticRenderFns } from "./DataGridView.vue?vue&type=template&id=0e60a135&"
import script from "./DataGridView.vue?vue&type=script&lang=js&"
export * from "./DataGridView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports